import CompanyPage from './company-page';
export default CompanyPage